<template>
  <SidebarSection
    v-if="dataInlandsfluege.length > 0"
    class="mt-10"
    title="Inlandsflüge"
    :collapsedOnMount="collapsedOnMount"
  >
    <SidebarListCard
      v-for="(data, i) in dataInlandsfluege"
      :key="'inlandflug-' + i"
      :index="i + 1"
      title="Inlandsflug"
    >
      <template #meta>
        <span v-for="meta in data[0].meta" :key="meta.label" class="inlandsflug__meta-eintrag">
          <span class="inlandsflug__meta-label">{{ meta.label }}</span>
          <span class="inlandsflug__meta-wert">{{ meta.wert }}</span>
        </span>
      </template>
      <SidebarFieldGrid>
        <SidebarFieldRow
          v-for="(item, j) in felder(data)"
          :key="'inlandsflug-' + i + item.label"
          :label="item.label"
          :column="(j % 2) + 1"
          :readonly="!item.editable"
        >
          <b-form-input
            v-if="item.editable && item.editType === 'input'"
            v-model="item.valueEdited"
            class="inlandsflug__input"
            debounce="1000"
            placeholder="-"
            @update="$emit('flugnummer-changed', data)"
          ></b-form-input>
          <b-form-checkbox
            v-else-if="item.editable && item.editType === 'checkbox'"
            v-model="item.valueEdited"
            size="lg"
            @change="$emit('flugnummer-changed', data)"
          ></b-form-checkbox>
          <span v-else>{{ item.value ?? '-' }}</span>
        </SidebarFieldRow>
        <SidebarFieldRow v-if="felder(data).length % 2 === 1" :column="2" />
      </SidebarFieldGrid>
    </SidebarListCard>
  </SidebarSection>
</template>

<script>
import SidebarSection from '@/components/common/sidebar-section/sidebar-section.vue';
import SidebarListCard from '@/components/common/sidebar-section/sidebar-list-card.vue';
import SidebarFieldGrid from '@/components/common/sidebar-section/sidebar-field-grid.vue';
import SidebarFieldRow from '@/components/common/sidebar-section/sidebar-field-row.vue';

export default {
  name: 'SidebarFlugplanungInlandsfluege',
  components: { SidebarSection, SidebarListCard, SidebarFieldGrid, SidebarFieldRow },
  props: {
    // Anzeige-Modell der Inlandsflüge (pro Inlandsflug ein Array von Detail-Feldern)
    dataInlandsfluege: { type: Array, default: () => [] },
    collapsedOnMount: { type: Boolean, default: false },
  },
  methods: {
    felder(data) {
      return data.filter(item => item.show && !item.meta);
    },
  },
};
</script>

<style scoped>
.inlandsflug__meta-eintrag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.inlandsflug__meta-label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text-muted);
}

.inlandsflug__meta-wert {
  font-size: 13px;
  font-weight: 600;
  color: var(--text);
}

.inlandsflug__input {
  height: var(--control-h-sm);
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 500;
  border-radius: var(--radius-sm);
}
</style>
